import {
  getAllCoupons,
  addCoupon,
  getCouponById,
  updateCouponById,
  inactiveCoupon,
} from "./CouponActions";
import { createSlice } from "@reduxjs/toolkit";

interface CouponState {
  coupons: any[] | null;
  couponsLoading: boolean;
  couponsError: any | null;

  addCouponData: any | null;
  addCouponDataLoading: boolean;
  addCouponDataError: any | null;

  couponById: any | null;
  couponByIdLoading: boolean;
  couponByIdError: any | null;

  updateCouponByIdData: any | null;
  updateCouponByIdLoading: boolean;
  updateCouponByIdError: any | null;

  inactiveCouponData: any | null;
  inactiveCouponLoading: boolean;
  inactiveCouponError: any | null;
}

const initialState: CouponState = {
  coupons: null,
  couponsLoading: false,
  couponsError: null,

  addCouponData: null,
  addCouponDataLoading: false,
  addCouponDataError: null,

  couponById: null,
  couponByIdLoading: false,
  couponByIdError: null,

  updateCouponByIdData: null,
  updateCouponByIdLoading: false,
  updateCouponByIdError: null,

  inactiveCouponData: null,
  inactiveCouponLoading: false,
  inactiveCouponError: null,
};

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCoupons.pending, (state) => {
      state.couponsLoading = true;
      state.couponsError = null;
      state.coupons = null;
    });
    builder.addCase(getAllCoupons.fulfilled, (state, action) => {
      state.coupons = action.payload;
      state.couponsLoading = false;
      state.couponsError = null;
    });
    builder.addCase(getAllCoupons.rejected, (state, action) => {
      state.couponsError = action.payload;
      state.couponsLoading = false;
      state.couponsError = action.payload;
    });

    builder.addCase(addCoupon.pending, (state) => {
      state.addCouponDataLoading = true;
      state.addCouponDataError = null;
      state.addCouponData = null;
    });
    builder.addCase(addCoupon.fulfilled, (state, action) => {
      state.addCouponData = action.payload;
      state.addCouponDataLoading = false;
      state.addCouponDataError = null;
    });
    builder.addCase(addCoupon.rejected, (state, action) => {
      state.addCouponDataError = action.payload;
      state.addCouponDataLoading = false;
      state.addCouponDataError = action.payload;
    });

    builder.addCase(getCouponById.pending, (state) => {
      state.couponByIdLoading = true;
      state.couponByIdError = null;
      state.couponById = null;
    });
    builder.addCase(getCouponById.fulfilled, (state, action) => {
      state.couponById = action.payload;
      state.couponByIdLoading = false;
      state.couponByIdError = null;
    });
    builder.addCase(getCouponById.rejected, (state, action) => {
      state.couponByIdError = action.payload;
      state.couponByIdLoading = false;
      state.couponByIdError = action.payload;
    });

    builder.addCase(updateCouponById.pending, (state) => {
      state.updateCouponByIdLoading = true;
      state.updateCouponByIdError = null;
      state.updateCouponByIdData = null;
    });
    builder.addCase(updateCouponById.fulfilled, (state, action) => {
      state.updateCouponByIdData = action.payload;
      state.updateCouponByIdLoading = false;
      state.updateCouponByIdError = null;
    });
    builder.addCase(updateCouponById.rejected, (state, action) => {
      state.updateCouponByIdError = action.payload;
      state.updateCouponByIdLoading = false;
      state.updateCouponByIdError = action.payload;
    });

    builder.addCase(inactiveCoupon.pending, (state) => {
      state.inactiveCouponLoading = true;
      state.inactiveCouponError = null;
      state.inactiveCouponData = null;
    });
    builder.addCase(inactiveCoupon.fulfilled, (state, action) => {
      state.inactiveCouponData = action.payload;
      state.inactiveCouponLoading = false;
      state.inactiveCouponError = null;
    });
    builder.addCase(inactiveCoupon.rejected, (state, action) => {
      state.inactiveCouponError = action.payload;
      state.inactiveCouponLoading = false;
      state.inactiveCouponError = action.payload;
    });
  },
});

const couponReducer = couponSlice.reducer;

export default couponReducer;
